import * as React from 'react'
import { Icon } from 'antd'
import { Tooltip } from 'antd-v4'
import { GrRegex } from '../../../utilities/helpers'
import { AsyncSearchInputWrapper } from './AsyncSearchInputWrapper'
import { IBaseProduct, productName } from '@getgreenline/homi-shared'

interface Props {
  value: string
  size?: 'small' | 'default' | 'large'
  productId: string | null
  disabled: boolean
  placeholder?: string
  onChange: (value: string) => void
  blockSaving?: (blockSaving: boolean, errorMessage?: string) => void
}

export class AsyncNameSearchInput extends React.Component<Props> {
  onChange = (value: string) => {
    this.props.onChange(value)

    if (this.props.blockSaving) {
      const blockSaving = this.getUniqueUnicodeArray(value) !== null
      this.props.blockSaving(blockSaving)
    }
  }

  filterProducts = (searchQuery: string, products: IBaseProduct[]) => {
    return products.filter((product) => {
      const escapedName = GrRegex.regEscape(searchQuery)
      const regexName = new RegExp(escapedName, 'ig')

      const isNameMatching = productName(product).match(regexName) !== null

      return this.props.productId
        ? isNameMatching && product.id !== this.props.productId
        : isNameMatching
    })
  }

  getUniqueUnicodeArray = (value: string): unknown[] | null => {
    const uniqueArray = value.toString().match(GrRegex.unicodeRegex)

    return uniqueArray === null ? null : [...new Set(uniqueArray)]
  }

  render() {
    const { value, size, productId, disabled, placeholder, blockSaving } = this.props
    const uniqueUnicodeArray = this.getUniqueUnicodeArray(value)

    return (
      <AsyncSearchInputWrapper
        value={value}
        size={size}
        wrapperClassName='d-flex'
        productId={productId}
        disabled={disabled}
        placeholder={placeholder}
        filterProducts={this.filterProducts}
        onChange={this.onChange}
        blockSaving={blockSaving}
      >
        {uniqueUnicodeArray !== null && (
          <div className='ml-3 align-self-center'>
            <Tooltip
              title={
                <div>
                  <div>Remove the following character(s)</div>
                  <div>{uniqueUnicodeArray.join(', ')}</div>
                </div>
              }
              placement='bottom'
            >
              <Icon type='warning' style={{ color: 'var(--red)' }} />
            </Tooltip>
          </div>
        )}
      </AsyncSearchInputWrapper>
    )
  }
}
